import React from 'react'
import _ from 'lodash'
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter'
import javascript from 'react-syntax-highlighter/dist/esm/languages/hljs/javascript'
import json from 'react-syntax-highlighter/dist/esm/languages/hljs/json'
import bash from 'react-syntax-highlighter/dist/esm/languages/hljs/bash'
import aitoSyntaxStyle from './hljs'
import Mermaid from './Mermaid'

SyntaxHighlighter.registerLanguage('javascript', javascript)
SyntaxHighlighter.registerLanguage('json', json)
SyntaxHighlighter.registerLanguage('bash', bash)

export default (props) => {
  let lang

  if (props.className) {
    lang = props.className.split(' ')[0].split('-')[1]
  }

  if (lang === 'mermaid') {
    return <Mermaid>{props.children}</Mermaid>
  }

  return (
    <SyntaxHighlighter language={lang} style={aitoSyntaxStyle}>{props.children}</SyntaxHighlighter>
  )
}
